import { filter, gt, gte, isEqual, isNil, isNull, isUndefined, map } from 'lodash';
import Link from 'next/link';
import { MouseEvent, useEffect, useState } from 'react';
import HomeLink from '../../shared/header2/home-link';

const Navbar = () => {
  const navigations = [
    {
      id: 'block-information',
      name: 'Block & khu',
    },
    {
      id: 'main-content',
      name: 'Thông tin',
    },
    {
      id: 'real-estate-in-project',
      name: 'Các loại BĐS trong dự án',
    },
    {
      id: 'legal-information',
      name: 'Pháp lý',
    },
    {
      id: 'project-location',
      name: 'Vị trí',
    },
    {
      id: 'utilities',
      name: 'Tiện ích',
    },
    {
      id: 'blueprint',
      name: 'Mặt bằng & Căn hộ mẫu',
    },
    {
      id: 'payment-process',
      name: 'Lộ trình thanh toán',
    },
    {
      id: 'loan-estimation',
      name: 'Ước tính khoản vay',
    },
  ];
  const [activeSection, setActiveSection] = useState('');
  const [filteredSections, _] = useState(() =>
    filter(navigations, (navigation) => !isNil(document.getElementById(navigation.id))),
  );

  const scrollToTargetAdjusted = (event?: MouseEvent<HTMLAnchorElement>, elementId?: string) => {
    event?.preventDefault();
    const element = document.getElementById(elementId ?? '');
    const headerOffset = document.getElementById('project-navbar' ?? '')?.offsetHeight;
    const elementPosition = element?.getBoundingClientRect().top;
    if (!isUndefined(elementPosition) && !isUndefined(headerOffset)) {
      const offsetPosition = elementPosition + window.pageYOffset - (headerOffset + 15);
      window.scrollTo({
        top: offsetPosition,
      });
    }
  };

  useEffect(() => {
    const scroll = () => {
      const sections = document.querySelectorAll('section');
      map(sections, (section) => {
        const sectionTop = section.offsetTop - 80;
        const sectionBottom = sectionTop + section.offsetHeight;
        const scrollPos = window.pageYOffset;
        if (gte(scrollPos, sectionTop) && gt(sectionBottom, scrollPos)) {
          setActiveSection(section.id);
        }
      });
    };
    window.addEventListener('scroll', scroll);
    return () => window.removeEventListener('scroll', scroll);
  }, []);
  useEffect(() => {
    const marker = document.getElementById('project-navbar-marker');
    const item = document.getElementById(`detail-project-${activeSection}-link`);
    if (!isNull(marker)) {
      marker.style.left = item?.offsetLeft + 'px';
      marker.style.width = item?.offsetWidth + 'px';
    }
  }, [activeSection]);

  return (
    <div
      id='project-navbar'
      className={`sticky top-0 left-0 right-0 z-[50] flex h-[64px] min-w-[1052px] animate-[collapse-top_500ms_linear] items-center space-x-[40px] border-b border-stroke bg-paper px-[24px] py-[12px] duration-[500ms]`}
    >
      <HomeLink />
      <nav>
        <ul className='flex select-none items-center space-x-[24px]'>
          {map(filteredSections, (navigation) => (
            <li
              key={`detail-project-${navigation.id}-link`}
              id={`detail-project-${navigation.id}-link`}
            >
              <Link
                href={`#${navigation.id}`}
                className={`${
                  isEqual(activeSection, navigation.id) && 'text-primary'
                } inline-block text-center font-[600] duration-[500ms] hover:text-primary`}
                onClick={(event) => scrollToTargetAdjusted(event, navigation.id)}
              >
                {navigation.name}
              </Link>
            </li>
          ))}
        </ul>
        <div
          id='project-navbar-marker'
          className='absolute bottom-0 h-[3px] w-0 bg-primary duration-[500ms]'
        />
      </nav>
    </div>
  );
};

export default Navbar;
